import moment from "moment";

export const getCorretDate = (fecha) => {
  return moment.utc(fecha).subtract(5, 'hours').format('DD/MM/YYYY')
} 

export default getCorretDate;
